import React from 'react';

import { TBlock } from '@wp-block-builder/package';

type Props = {
  block: Extract<TBlock, { type: 'Container' }>;
  BlockComponent: (props: { block: TBlock }) => JSX.Element;
};

export function ContainerBlock({ block, BlockComponent }: Props) {
  const blocks = block.props?.blocks ?? [];
  return (
    <>
      {blocks.map((block, i) => (
        <BlockComponent key={i} block={block} />
      ))}
    </>
  );
}
